import { gql } from "@apollo/client";

// Feeds the starter prompts under the homepage Ask AI input: the current user's
// next meetings, so we can offer "prep my 1-on-1 with X" / "prep my meeting".
export default gql`
  query getAskAiPromptSuggestionsQuery(
    $participants: [Int]!
    $startDatetimeGte: DateTime!
    $startDatetimeLte: DateTime!
    $meetingMax: Int!
  ) {
    meetings(
      participants: $participants
      startDatetime_Gte: $startDatetimeGte
      startDatetime_Lte: $startDatetimeLte
      orderBy: "startDatetime"
      ignored: false
      status: confirmed
      first: $meetingMax
    ) {
      edges {
        node {
          id
          title
          startDatetime
          endDatetime
          meetingGroup {
            id
            isFormalOneonone
          }
          participants(first: 5) {
            edges {
              node {
                id
                user {
                  id
                  name
                  firstName
                }
              }
            }
          }
        }
      }
    }
  }
`;
